import React from 'react';
import { tierHeadline } from '../lib/tierPercentile';

export default function Tier({ tier }) {
  const headline = tierHeadline(tier);
  return (
    <div style={containerStyle} data-testid="tier-card">
      <div style={labelStyle}>{tier || 'Pending'}</div>
      {headline && <div style={headlineStyle}>{headline}</div>}
    </div>
  );
}

const containerStyle = {
  background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
  color: 'white',
  borderRadius: '12px',
  padding: '24px',
  textAlign: 'center',
};

const labelStyle = {
  fontSize: '32px',
  fontWeight: 700,
  letterSpacing: '-0.02em',
  marginBottom: '4px',
};

const headlineStyle = {
  fontSize: '14px',
  color: '#cbd5e1',
  fontWeight: 500,
};
